import { Component, OnInit, Input } from "@angular/core"
import { MonthViewDay } from "calendar-utils"
import { Store, Action } from "@ngrx/store"
import { ModalService } from "@services/modal"
import { CalendarEffects } from "@reducers/effects/calendar"
import { AppState } from "@store/app-state"
import { CalendarStore } from "@store/calendar"
import { Observable } from "rxjs/Observable"
import { PublicHoliday } from "@models/public-holiday"
import { Term } from "@models/term"
import * as moment from "moment"
import {
  UPDATE_TERM,
  POPULATE_EDITABLE_TERM,
  CREATE_TERM,
  POPULATE_EDITABLE_PUBLIC_HOLIDAY,
  UPDATE_PUBLIC_HOLIDAY,
  CREATE_PUBLIC_HOLIDAY,
  DESTROY_PUBLIC_HOLIDAY
} from "@reducers/calendar"
import { Utilities } from "@helpers/utilities"

@Component({
  selector: 'calendar-day-form',
  templateUrl: './calendar-day-form.pug',
})
export class CalendarDayFormComponent implements OnInit {

  public day: MonthViewDay
  public term: Term
  public publicHoliday: PublicHoliday

  constructor(
    private store: Store<AppState>,
    private calendarEffects: CalendarEffects,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.store.select("calendarReducer").subscribe((s: CalendarStore) => {
      this.day            = s.activeDay
      this.term           = s.editableTerm
      this.publicHoliday  = s.editablePublicHoliday
    })
    this.setupTerm()
    this.setupPublicHoliday()
    this.setupEventEffects()
  }

  setupTerm() {
    if (!this.isEditingTerm()) {
      this.term.number      = 1
      this.term.startDate   = moment(this.day.date).toDate()
      this.term.endDate     = moment(this.day.date).add(7, "days").toDate()
    }
  }

  setupPublicHoliday() {
    if (!this.isEditingPublicHoliday()) {
      this.publicHoliday.date   = moment(this.day.date).toDate()
      this.publicHoliday.state  = "NSW"
    }
  }

  setupEventEffects() {
    Observable.merge(
      this.calendarEffects.createTerm,
      this.calendarEffects.updateTerm,
      this.calendarEffects.createPublicHoliday,
      this.calendarEffects.updatePublicHoliday,
      this.calendarEffects.destroyPublicHoliday,
    ).subscribe((a: Action) => {
      switch (a.type) {
        default:
          this.modalService.closeModal()
      }
    })
  }

  getCalculatedEndDate(): Date {
    let result: Date

    if (this.term.isHoliday) {
      result = moment(this.term.startDate)
        .add(10, "days")
        .toDate()
    }
    else {
      result = moment(this.term.startDate)
        .add(9, "weeks")
        .subtract(1, "days")
        .toDate()
    }

    return result
  }

  getDayOfStartDate(): number {
    return moment(this.term.startDate).day()
  }

  setEndDateFromStartDate() {
    this.term.endDate = this.getCalculatedEndDate()
  }

  getEventClassNames(type: string) {
    return type.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
  }

  isEditingTerm(): boolean {
    return !!this.term.id
  }

  isEditingPublicHoliday(): boolean {
    return !!this.publicHoliday.id
  }

  clickedSubmitTerm() {
    this.setEndDateFromStartDate()
    const targetAction: string = this.isEditingTerm() ? UPDATE_TERM : CREATE_TERM
    this.store.dispatch({ type: targetAction, payload: this.term })
  }

  clickedSubmitPublicHoliday() {
    const targetAction: string = this.isEditingPublicHoliday() ? UPDATE_PUBLIC_HOLIDAY : CREATE_PUBLIC_HOLIDAY
    this.store.dispatch({ type: targetAction, payload: this.publicHoliday })
  }

  clickedDeletePublicHoliday() {
    this.store.dispatch({ type: DESTROY_PUBLIC_HOLIDAY, payload: this.publicHoliday.id })
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/calendar-day-form.ts